import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const Tag = ({ className, ...props }: IProps) => {
  const iconClassName = classNames('tag-icon', className);

  return (
    <svg className={iconClassName} width='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 1.25002C22.4142 1.25002 22.75 1.5858 22.75 2.00002V12.3107L12.5304 22.5303C12.2375 22.8232 11.7626 22.8232 11.4697 22.5303L1.46967 12.5303C1.32902 12.3897 1.25 12.1989 1.25 12C1.25 11.8011 1.32902 11.6103 1.46967 11.4697L11.6893 1.25002H22ZM19.5002 6.00002C19.5002 5.17159 18.8286 4.50002 18.0002 4.50002C17.1718 4.50002 16.5002 5.17159 16.5002 6.00002C16.5002 6.82844 17.1718 7.50002 18.0002 7.50002C18.8286 7.50002 19.5002 6.82844 19.5002 6.00002ZM7.27539 13.7071L10.2754 16.7071L11.6896 15.2929L8.6896 12.2929L7.27539 13.7071Z'
        fill='currentColor'
        {...props}
      />
    </svg>
  );
};

export default Tag;
